var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{attrs:{"cols":"12","md":"10","lg":"10","offset":"0","offset-md":"1","offset-lg":"1"}},[_c('v-skeleton-loader',{staticClass:"mx-auto",attrs:{"type":"card-avatar, article, actions"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }